/**
 * Een Google Meet-link, zoals de beheerder hem bij een kamer zet.
 *
 * ALLEEN meet.google.com, EN DAT IS EEN BESLUIT. De knop in de kamer heet
 * "Google Meet" en de gast tikt erop zonder na te denken - hij komt van de
 * gesprekspartner. Een willekeurig adres toestaan zou van die knop een link
 * naar overal maken, met het vertrouwen van de kamer erbovenop. Moet er ooit
 * een ander videoprogramma bij, zet het dan hier bij naam neer.
 *
 * Zelfde regel voor server en browser: de browser toont de fout meteen, de
 * server is de rem die telt.
 */

const MEET_HOST = 'meet.google.com';

/** Maximale lengte. Een echte Meet-link is ruim onder de 100 tekens. */
export const MEET_LINK_MAX = 200;

/**
 * Maakt een ingetypte link netjes, of geeft null als het geen Meet-link is.
 *
 * Een link zonder https:// ervoor wordt aangevuld: wie "meet.google.com/abc"
 * plakt, bedoelt precies dat. Een http://-link wordt geweigerd en niet
 * omgezet - dan is er iets anders aan de hand dan een vergeten voorvoegsel.
 */
export function normaliseerMeetLink(invoer: string): string | null {
  const kaal = invoer.trim();
  if (kaal === '' || kaal.length > MEET_LINK_MAX) return null;

  const metSchema = /^[a-z][a-z0-9+.-]*:/i.test(kaal) ? kaal : `https://${kaal}`;

  let url: URL;
  try {
    url = new URL(metSchema);
  } catch {
    return null;
  }

  if (url.protocol !== 'https:') return null;
  if (url.hostname.toLowerCase() !== MEET_HOST) return null;
  // Geen gebruikersnaam of wachtwoord in het adres: https://meet.google.com@
  // elders.nl is een klassieke truc om een ander adres te laten lijken.
  if (url.username !== '' || url.password !== '') return null;
  if (url.port !== '') return null;
  // Alleen de hoofdpagina is geen vergadering.
  if (url.pathname === '/' || url.pathname === '') return null;

  return url.toString();
}
